<template>
	<el-card shadow="never" class="l-main-card">
		<div class="l-table-toolbar">
			<l-auth-button type="primary" auth="mt_company_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
			<div class="l-simple-search-container">
				<el-input placeholder="请输入企业名称" v-model="search_data.name" class="input-with-select">
					<el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
				</el-input>
			</div>
		</div>
		<l-table :data="data" v-loading="loading" row-key="id">
			<el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>
			<el-table-column prop="name" label="企业名称" min-width="200"> </el-table-column>
			<el-table-column label="企业类型" min-width="200">
				<template>
					<el-tag size="mini" type="danger">维修服务商</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="创建时间" width="180"> </el-table-column>
			<el-table-column prop="update_time" label="修改时间" width="180"> </el-table-column>

			<el-table-column fixed="right" label="操作" width="250" align="center">
				<template slot-scope="{ row }">
					<el-dropdown trigger="click" @command="(command) => handleComandClick(command, row)">
						<span class="el-dropdown-link"> 其他操作<i class="el-icon-arrow-down el-icon--right"></i> </span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="mt_admin">维修管理员信息</el-dropdown-item>
							<el-dropdown-item command="dev_type">管理可报修设备</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<span class="l-action-separator">|</span>
					<l-auth-text-button type="danger" auth="mt_company_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
				</template>
			</el-table-column>
		</l-table>

		<!--添加-->
		<l-dialog class="l-dialog-no-footer" :visible.sync="add_visible" title="添加维修厂家" width="1000px">
			<l-mt-company-add @on-success="onAddSucess" @on-company-add-success="getList" :visible.sync="add_visible" :company-id="companyId"></l-mt-company-add>
		</l-dialog>

		<!--编辑-->
		<l-dialog :visible.sync="edit_visible" title="编辑企业" width="500px">
			<l-org-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
		</l-dialog>

		<!--管理可报修设备-->
		<l-dialog class="l-dialog-no-footer" :visible.sync="dev_visible" title="管理可报修设备" width="1000px">
			<l-mt-dev-index-model :visible.sync="dev_visible" :company-id="companyId" :mt-company-id="mt_company_id" />
		</l-dialog>

		<!--修改维修管理员-->
		<l-dialog :visible.sync="mt_admin_visible" title="维修管理员信息" width="500px">
			<l-user-edit-mt-admin @on-success="onMtAdminEditSuccess" :visible.sync="mt_admin_visible" :company-id="companyId" :mt-company-id="mt_company_id" />
		</l-dialog>
	</el-card>
</template>

<script>
import Edit from "../org/Edit";
import Add from "./Add";
import CompanyIndex from "../dev_type/CompanyIndex";
import MtDev from "../mt_dev/IndexModel";
import EditMtAdmin from "../user/EditMtAdmin";
export default {
	name: "l-mtc-company",
	components: {
		[Edit.name]: Edit,
		[Add.name]: Add,
		[CompanyIndex.name]: CompanyIndex,
		[MtDev.name]: MtDev,
		[EditMtAdmin.name]: EditMtAdmin,
	},
	props: {
		companyId: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			data: [],
			count: 0,
			loading: false,
			change_state_loading: [],

			add_visible: false, //是否显示添加

			edit_visible: false, //是否显示编辑
			edit_id: 0,

			company_id: "",

			dev_visible: false, //是否显示设备类型管理
			mt_admin_visible: false, //是否显示维修管理员信息
			mt_company_id: "",

			//搜索
			search_visible: false,
			search_data: {
				name: "",
			},
			rel_search_data: {},
			show_more_search: false,
		};
	},

	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getList();
				}
			},
		},
	},

	mounted() {
		// this.getList();
	},

	methods: {
		//获取数据
		getList() {
			this.loading = true;
			this.$_invoke("org_getMtcCompanyListByCompanyId", {
				company_id: this.$props.companyId,
				...this.rel_search_data,
			})
				.then((ret) => {
					this.data = ret.data;
					this.count = ret.count;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		//点击搜索按钮
		onSearch() {
			this.rel_search_data = this.search_data;
			this.getList();
		},

		//点击重置搜索框
		onReset() {
			this.$refs.search_form.resetFields();
			this.rel_search_data = {};
		},

		//修改状态
		changeState(row) {
			this.change_state_loading.push(row.id);
			this.$_invoke(`resource_updState`, {
				id: row.id,
				state: row.state,
			})
				.then((ret) => {
					row.state = ret.state;
					this.$_msg.success("修改状态成功");
				})
				.catch((e) => {
					console.log(e);
				})
				.finally(() => {
					this.change_state_loading = this.change_state_loading.filter((item) => {
						return item != row.id;
					});
				});
		},

		//添加成功回调
		onAddSucess() {
			this.add_visible = false;
			this.getList();
		},

		//显示修改界面
		showEdit(id) {
			this.edit_id = id;
			this.$nextTick(() => {
				this.edit_visible = true;
			});
		},

		//编辑成功回调
		onEditSuccess() {
			this.edit_visible = false;
			this.getList();
		},

		//显示修改密码界面
		showChangePwd(id) {
			this.change_pwd_id = id;
			this.$nextTick(() => {
				this.show_change_pwd = true;
			});
		},

		//修改密码成功回调
		onChangePwdSuccess() {
			this.show_change_pwd = false;
		},

		//删除
		del(id) {
			this.$confirm("确定删除该维修厂家吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$_invoke(`org_deleteMtCompany`, { id, company_id: this.$props.companyId }).then(() => {
						this.$_msg.success("删除成功");
						this.getList();
					});
				})
				.catch(() => {});
		},

		//显示企业对应的设备类型
		showDev(id) {
			this.mt_company_id = id;
			this.dev_visible = true;
		},

		//修改/添加维修厂家管理员
		showMtAdmin(id) {
			this.mt_company_id = id;
			this.mt_admin_visible = true;
		},

		//修改/添加维修厂家管理员成功回到
		onMtAdminEditSuccess() {
			this.mt_company_id = "";
			this.mt_admin_visible = false;
		},

		//处理点击下拉菜单事件
		handleComandClick(command, row) {
			switch (command) {
				case "dev_type":
					this.showDev(row.id);
					break;
				case "mt_admin":
					this.showMtAdmin(row.id);
					break;
			}
		},
	},
};
</script>
